export default {
  title: "Actividades",
  subtitle: "Todas las actividades de la plataforma",
  searchPlaceholder: "Buscar por actividad o propietario...",
  loadError: "No se pudieron cargar las actividades",
  retry: "Reintentar",
  empty: "Ninguna actividad coincide con los filtros.",
  openRowAria: "Abrir actividad {{name}}",
  filters: {
    status: "Estado",
    statusAll: "Todas",
    statusActive: "Activas",
    statusInactive: "Inactivas",
    visibility: "Visibilidad",
    visibilityAll: "Todas",
    visibilityVisible: "Visibles",
    visibilityHidden: "Ocultas",
    discounts: "Descuentos",
    discountsAll: "Todos",
    discountsActive: "Descuentos activos",
    category: "Categoría",
    categoryAll: "Todas",
    paymentModel: "Método de pago",
    paymentModelAll: "Todos",
  },
  paymentModels: {
    upfront: "Pago anticipado",
    receiptBased: "Por recibo",
  },
  categories: {
    restaurant: "Restaurante",
    attraction: "Atracción",
    genericService: "Servicio",
  },
  columns: {
    name: "Actividad",
    category: "Categoría",
    owner: "Propietario",
    paymentModel: "Método de pago",
    commission: "Comisión",
  },
} as const;
